var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableVideoActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "currentFill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1993_1509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0708 35.7359V43.2643C28.0708 44.6137 28.6745 45.8211 29.6155 46.6199L44.1485 32.087C43.4294 31.5898 42.5593 31.2969 41.6272 31.2969H32.5096C30.0593 31.2969 28.0708 33.2856 28.0708 35.7359Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6695 27.3307C52.3232 26.9845 51.7606 26.9845 51.4143 27.3307L28.332 50.4131C27.9857 50.7594 27.9857 51.322 28.332 51.6682C28.5051 51.8425 28.7314 51.929 28.9589 51.929C29.1864 51.929 29.4128 51.8425 29.587 51.6693L33.5532 47.7031H41.6288C44.0702 47.7031 46.0677 45.7145 46.0677 43.2642V42.8114L50.2404 45.315C50.7998 45.6524 51.4656 45.6612 52.0338 45.3416C52.5919 45.022 52.9293 44.445 52.9293 43.7969V35.2031C52.9293 34.5551 52.592 33.978 52.0327 33.6584C51.4645 33.3388 50.7986 33.3477 50.2393 33.685L46.0666 36.1886V35.7358C46.0666 35.5649 46.0411 35.4006 46.0211 35.2342L52.6694 28.5859C53.0156 28.2397 53.0157 27.6781 52.6695 27.3307Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1993_1509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "currentFill",
    transform: "translate(28 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableVideoActive);
export default __webpack_public_path__ + "static/media/DisableVideoActive.6f9066507f8c72f2cce4f23a88ea52d3.svg";
export { ForwardRef as ReactComponent };